import React, { useCallback, forwardRef } from 'react'
import { useDispatch } from 'react-redux'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import fertilizerManufacturerSchema from '@galo-monitor/forms/schemas/root/fertilizerManufacturer.schema'
import { useT } from '@galo-monitor/i18n'
import { useSnackbar } from '@galo-monitor/snackbar'
import { FertilizerActions } from '@galo-monitor/stores/fertilizer'
import Form from '@galo-monitor/web-components/Form'
import InputText from '@galo-monitor/web-components/InputText'

import { Container } from './theme'

const FertilizerManufacturerForm = forwardRef((props, formRef) => {
  const {
    manufacturer,
    loading,
    setLoading,
    onSuccess,
    onError
  } = props
  const dispatch = useCallback(useDispatch(), [])
  const t = useT()
  const snackbar = useSnackbar()

  const handleSubmit = useCallback(
    (data) => {
      setLoading(true)

      dispatch(FertilizerActions.saveFertilizerManufacturer(
        {
          ...manufacturer,
          ...data
        },
        () => {
          snackbar.success(t('{this} {action} successfully!', {
            this: t('manufacturer', { howMany: 1 }),
            action: toLower(t(isEmpty(manufacturer) ? 'created' : 'updated', { gender: 'male', howMany: 1 }))
          }))
          onSuccess()
        },
        onError
      ))
    },
    [manufacturer, dispatch, onError, onSuccess, setLoading, snackbar, t]
  )

  return (
    <Form
      ref={ formRef }
      schemaConstructor={ fertilizerManufacturerSchema }
      onSubmit={ handleSubmit }
    >
      <Container>
        <InputText
          name="name"
          label={ t('trade name') }
          defaultValue={ manufacturer?.name ?? '' }
          disabled={ loading }
          fullWidth
        />
      </Container>
    </Form>
  )
})

FertilizerManufacturerForm.propTypes = {
  manufacturer: PropTypes.object,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func
}

FertilizerManufacturerForm.defaultProps = {
  manufacturer: {},
  loading: false,
  setLoading: () => {},
  onSuccess: () => {},
  onError: () => {}
}

export default FertilizerManufacturerForm
